import React from "react";
import { translate } from "../../utils/i18n";

function BellIcon() {
  return (
    <svg
      aria-hidden="true"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.27 21a2 2 0 0 0 3.46 0" />
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
    </svg>
  );
}

export default function NotificationDropdown({
  notifications = [],
  unreadNotificationCount = 0,
  showNotifications = false,
  setShowNotifications = () => {},
  handleNotificationClick = () => {},
  markAllNotificationsAsRead = () => {},
  isMobile = false,
  styles = {},
  language = "en",
}) {
  const t = (key) => translate(language, key);

  return (
    <div id="rentduo-notification-root" style={styles.notificationWrap}>
      <button
        style={styles.notificationBellButton}
        onClick={() => setShowNotifications((prev) => !prev)}
        aria-label={t("notificationLabel")}
        type="button"
      >
        <BellIcon />
      </button>
      {unreadNotificationCount > 0 ? (
        <div style={styles.notificationBadge}>
          {unreadNotificationCount > 99 ? "99+" : unreadNotificationCount}
        </div>
      ) : null}

      {showNotifications ? (
        <>
          <div
            style={isMobile ? styles.notificationBackdrop : styles.notificationBackdropDesktop}
            onClick={() => setShowNotifications(false)}
          />
          <div
            style={{
              ...styles.notificationDropdown,
              ...(isMobile ? styles.notificationDropdownMobile : styles.notificationDropdownDesktop),
            }}
            className="rentduo-scrollbar"
          >
            <div style={styles.notificationDropdownHeader}>
              <span>{t("notifications")}</span>
              {unreadNotificationCount > 0 ? (
                <button
                  type="button"
                  style={
                    styles.notificationMarkAllButton || {
                      border: 0,
                      background: "transparent",
                      color: "#0f6fff",
                      fontWeight: 800,
                      cursor: "pointer",
                    }
                  }
                  onClick={(event) => {
                    event.stopPropagation();
                    markAllNotificationsAsRead();
                  }}
                >
                  {t("markAllRead")}
                </button>
              ) : null}
            </div>
            {notifications.length ? (
              notifications.map((item) => (
                <button
                  key={item.id}
                  style={{
                    ...styles.notificationItem,
                    ...(item?.read ? styles.notificationItemRead : styles.notificationItemUnread),
                  }}
                  onClick={() => handleNotificationClick(item)}
                >
                  <div style={styles.notificationItemTitle}>{item.title || t("notifications")}</div>
                  <div style={styles.notificationItemBody}>{item.body || ""}</div>
                </button>
              ))
            ) : (
              <div style={styles.notificationEmpty}>{t("notificationEmpty")}</div>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
}
